import { Box, Heading } from '@chakra-ui/react';
import ChakraUIRenderer from 'chakra-ui-markdown-renderer';
import Articles from 'components/articles';
import Layout from "components/layout";
import { Pagination } from 'components/pagination/Pagination';
import { fetchAPI } from "lib/api";
import dynamic from 'next/dynamic';
import Seo from '../../../../components/seo';
import { lightTheme } from '../../../../lib/lightmarkdown';
const MarkdownInterpreter = dynamic( () => import( 'markdown-to-jsx' ) );

const GuidesCategory = ( { posts, category } ) => {

	const seo = {
		metaTitle: category.attributes.seo.metaTitle,
		metaDescription: category.attributes.seo.metaDescription,
		shareImage: category.attributes.thumbnail,
		canonical: category.attributes.seo.canonical,
	};

	return (
		<Layout categories={ category }>
			<Seo seo={ seo } />
			<Box as="section" py="12" maxW={ { base: 'xl', md: '7xl' } } mx="auto" px={ { base: '6', md: '8', } }>
				<Heading as="h1" fontSize="3xl" variant="brand1" mb="4" fontWeight={ 'normal' }>{ category.attributes.name }</Heading>
				{ category.attributes.description && (
					<MarkdownInterpreter options={ {
						forceBlock: true,
						overrides: ChakraUIRenderer( lightTheme ),
					} }>{ category.attributes.description }</MarkdownInterpreter>
				) }
				<Articles articles={ posts.data } />
				<Pagination page={ posts.meta.pagination.page } totalPages={ posts.meta.pagination.pageCount } basePath={ `/guide/tema/${category.attributes.slug}` } />
			</Box>
		</Layout>
	);
};

export async function getStaticPaths() {

	const [categoriesRes] = await Promise.all( [
		fetchAPI( "/post-categories", {
			populate: "*"
		} )
	] );

	// Get paths from categories
	const params = categoriesRes.data.map( ( category, i ) => `/guide/tema/${category.attributes.slug}/${i + 2}` );

	return {
		paths: params,
		fallback: 'blocking',
	};
}

export async function getStaticProps( { params } ) {

	const page = Number( params.slug[1] ) || 1;

	if ( params.slug[1] === '1' ) {
		return {
			redirect: {
				destination: `/guide/tema/${params.slug[0]}`,
				permanent: true,
			},
		};
	}

	// Transform slug removing dash and replacing spaces with dash

	const [postsRes, categoriesRes] = await Promise.all( [
		fetchAPI( "/posts", {
			filters: {
				postCategory: {
					slug: params.slug[0]
				}
			},
			fields: ["title", "slug", "thumbnail", "postCategory", "postAuthor"],
			populate: {
				"postAuthor": {
					"fields": ["name"],
					"populate": {
						"picture": {
							"fields": "url"
						}
					}
				},
				"postCategory": {
					"fields": ["name", "slug"]
				},
				"thumbnail": {
					"fields": "url"
				}
			},
			// populate: ["thumbnail", "postCategory", "postAuthor.picture", "seo"],
			pagination: {
				page: page,
				pageSize: 10
			}
		} ),
		fetchAPI( "/post-categories", {
			populate: "*",
			filters: { slug: params.slug[0] }
		} )
	] );

	return {
		props: {
			posts: postsRes,
			category: categoriesRes.data[0],
		},
		revalidate: 60 * 60 * 24 // Once a day
	};

}

export default GuidesCategory;
